import React from 'react';
import PropTypes from 'prop-types';
import '../styles/hcHomepageStyles.css';

export const LanguageChanger = (props) => {
    return (
        <button 
            className="languageButton"
            onClick={props.handleClick}>
            {props.buttonText}
        </button>
    );  
};

LanguageChanger.propTypes = {
    handleClick: PropTypes.func.isRequired,
    buttonText: PropTypes.string.isRequired,
};

export default LanguageChanger;




// WEBPACK FOOTER //
// ./src/components/LanguageChanger.jsx